import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import {BuilderPage} from "./pages/BuilderPage";
import {MyPage} from "./pages/MyPage";
import {DashboardPage} from "./pages/DashboardPage";
import FicheListPage from "./pages/Fiches/FicheListPages/FicheListPage";
import LocationsPage from "./pages/Configurations/Locations/LocationsPage";
import DonneTechniquePage from "./pages/Configurations/DonneeTechiniques/DonneTechniquePage";
import UnauthenticatedNewFichePage from "./pages/Fiches/UnauthenticatedNewFichePage/UnauthenticatedNewFichePage";
import FicheRecapitulatifPage from "./pages/Unauthenticated/FicheRecapitulatif/FicheRecapitulatifPage";
import UserInfo from "./pages/Gestion/UserInfo/UserInfo";
import FicheDetailsPage from "./pages/Unauthenticated/FicheDetails/FicheDetailsPage";
import AutoVerifyEmail from "./pages/Unauthenticated/AutoVerifyEmail/AutoVerifyEmail";

const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);

const UsersPage = lazy(() =>
  import('../app/pages/Configurations/Users/UsersPage')
);

export default function BasePage() {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/dashboard"/>
                }

                <Route path="/auth/email/auto-verify/:code" exact={true} component={AutoVerifyEmail}/>

                <ContentRoute path="/dashboard" component={DashboardPage}/>
                <ContentRoute path="/builder" component={BuilderPage}/>
                <ContentRoute path="/my-page" component={MyPage}/>


                <ContentRoute path="/configurations/users" component={UsersPage}/>
                <ContentRoute path="/configurations/donnees/geographique" component={LocationsPage}/>
                <ContentRoute path="/configurations/donnees/techniques" component={DonneTechniquePage}/>

                <ContentRoute path="/fiches" exact={true} component={FicheListPage}/>
                <ContentRoute path="/fiches/search" component={FicheListPage}/>

                <ContentRoute path="/account" component={UserInfo}/>

                <Route path="/fiches/details/:id"  component={FicheDetailsPage}/>

                <Route path="/fiches/create" exact={true} component={UnauthenticatedNewFichePage}/>
                <Route path="/fiches/recapitulatif/:ficheCode" exact={true} component={FicheRecapitulatifPage}/>

                <Route path="/google-material" component={GoogleMaterialPage}/>
                <Route path="/react-bootstrap" component={ReactBootstrapPage}/>
                <Route path="/e-commerce" component={ECommercePage}/>
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
